'use client';

import {
  APPOINTMENT_REASON_DEFINITIONS,
  DEFAULT_APPOINTMENT_REASON,
} from '@/lib/appointment/reasons';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

/**
 * Appointment reason options for the booking form select.
 */
export function useAppointmentReasonOptions() {
  const t = useTranslations('appointment.reasons');

  const options = useMemo(
    () =>
      APPOINTMENT_REASON_DEFINITIONS.map((definition) => ({
        label: t(definition.translationKey),
        value: definition.value,
      })),
    [t]
  );

  const defaultOption =
    options.find((option) => option.value === DEFAULT_APPOINTMENT_REASON) ?? options[0];

  return { options, defaultOption };
}
